// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeSunbit_titleIcon__2PTB7","inputPhoneContainer":"ViewChargeSunbit_inputPhoneContainer__1ZZdt"};